module.exports = __webpack_public_path__ + "img/162.81b1c4a3.jpg";